import { GoogleOAuthProvider } from "@react-oauth/google";
import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";

import { FaEye, FaEyeSlash, FaRegUser, FaArrowLeft, FaStar } from "react-icons/fa"; // Added FaStar for rating
import { MdOutlineMail, MdPhone } from "react-icons/md";
import PhoneInput from "react-phone-input-2";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import LoginService from "../../api/LoginService";
import { API_URL } from "../../config/app-config";
import {
  CLIENT_ID,
  GOOGLE_CLIENT_ID,
  KEY_CLOAK_URL,
} from "../../config/keycloak-config";
import Notfound from "../../images/icons/page-not-found.png";
import login from "../../images/hero-image.jpg";

import { getLocalStorage, isValidEmail, passwordCheck } from "../../utils";
import { getAllCountryName } from "../../redux/actions/commonApiActions";
import {
  getUserDetailsByToken,
  keyCloakLoader,
  loginErrorUpdate,
  mobileNumberRegister,
  registerErrorUpdate,
  socialKeyClockLoginAction,
  updateKeyCloakToken,
} from "../../redux/actions/loginDetailsActions";
import { language } from "../../sampleData/Options";
import GoogleLogin from "../../screens/Login/LoginV2/GoogleLogin";
import OtpInput from "../../screens/Login/LoginV2/OtpInput";
import { dBody, dropFlowStyle } from "../../components/Utils";
import "./womenconnectLoginpage.css";


function WomenConnectLoginpage(props) {
  const { onBack } = props; // Accept onBack prop for returning to home/parent
  const dispatch = useDispatch();
  const [state, setState] = useState({
    screen: "login",
    email: "",
    password: "",
    firstName: "",
    lastName: "",
    confirmPassword: "",
    inputType: "password",
    cInputType: "password",
    forgot: false,
    name: "",
    country: "",
    phoneNumber: "",
    menu: 0,
    countryList: [],
    otp: "",
    signInStatus: "",
    onResentOtp: false,
    language: { label: "English", value: "English" },
    isLoginScreen: false,
  });
  
  const countryList = useSelector((state) => state.commonApi.countryName);
  const {
    loginLoader,
    loginError,
    userLoggedIn,
    loginUserError,
    loginDetails,
    registerErrorStatus,
    loginErrorMessage,
  } = useSelector((state) => state.loginDetailsApi);

  useEffect(() => {
    if (countryList.length > 0 && state.countryList?.length === 0) {
      const list = countryList.map((item) => {
        return { value: item.iso, label: item.nicename, id: item.id };
      });
      updateState("countryList", list);
    }
  }, [countryList, state]);

  useEffect(() => {
    dispatch(keyCloakLoader(false));
    dispatch(getAllCountryName());
    const token = getLocalStorage("R_TOKEN");
    if (!userLoggedIn && token) {
      const details = {
        token: token,
        client_id: CLIENT_ID,
      };
      dispatch(getUserDetailsByToken(details));
    }
  }, []);

  useEffect(() => {
    if (userLoggedIn) {
      props.history.push(
        `/${
          loginDetails?.defaultWorkSpace
            ? loginDetails?.defaultWorkSpace
            : "default"
        }/home`
      );
    }
    if (loginError) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text:
          loginUserError === "blocked_by_admin"
            ? "Your login has been blocked by the admin. Please contact support"
            : loginErrorMessage
            ? loginErrorMessage
            : "Something went wrong, to login!",
      });
      dispatch(loginErrorUpdate(false));
    }
    if (registerErrorStatus) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `${
          registerErrorStatus
            ? registerErrorStatus
            : "Something went wrong, please try later!"
        }!`,
      });
      dispatch(registerErrorUpdate(null));
    }
  }, [loginError, userLoggedIn, registerErrorStatus]);

  const updateState = (name, value) => {
    setState((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  const backToMainLogin = () => {
    setState((previous) => ({
      ...previous,
      screen: "login",
      isLoginScreen: false,
      phoneNumber: "",
      otp: "",
      name: "",
      country: "",
      email: "",
      password: "",
    }));
  };

  // Handle back to home/parent if onBack prop is provided
  const handleBackToHome = () => {
    if (onBack) {
      onBack(); // Call parent callback to hide login and return to home
    } else {
      // Fallback: navigate to home via router if no prop
      props.history.push("/home");
    }
  };

  const updateToken = (type, token) => {
    if (token?.access_token) {
      dispatch(socialKeyClockLoginAction(type, token?.access_token));
    } else {
      console.log(`Access token not present`);
      errorGettingToken(type, token);
    }
  };

  const errorGettingToken = (type, e) => {
    console.error(`Error getting ${type} token :`, e);
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something went wrong, when try to get your social login details!",
    });
  };

  const submitForm = (e, resend) => {
    e.preventDefault();
    e.stopPropagation();
    if (!state.country?.value && state.screen !== "mobile-signIn") { // Fixed logical operator
      toast.warning("Select your country");
    } else if (
      state.phoneNumber.length <= 8 ||
      state.phoneNumber.length >= 16
    ) {
      toast.warning("Enter valid phone number");
    } else {
      dispatch(keyCloakLoader(true));
      let data = {
        phoneNumber: state.phoneNumber,
      };
      if (state.screen === "mobile-signIn") {
        LoginService.phoneExitCheck(data)
          .then((response) => {
            if (response.data.data === "PHONE_NUMBER_EXIST") {
              loginOtpSend(resend);
            } else {
              Swal.fire({
                title: "PHONE NUMBER NOT EXIST",
                showCancelButton: true,
                confirmButtonText: "Create New Account",
                cancelButtonText: "Reenter Phone Number",
                reverseButtons: true,
                icon: "warning",
                iconHtml: <img src={Notfound} alt="not-found" style={{width: "50px", height: "50px"}} />,
              }).then((result) => {
                if (result.value) {
                  updateState("screen", "register");
                }
              });
            }
            dispatch(keyCloakLoader(false));
          })
          .catch((error) => {
            if (error?.message === "Network Error") {
              Swal.fire({
                title: "Network issue detected. Kindly verify your connection.",
                confirmButtonText: "Try Again",
                reverseButtons: true,
                icon: "warning",
              });
            } else {
              Swal.fire({
                title: "We encountered an issue. Please log in again!",
                confirmButtonText: "Try Again",
                reverseButtons: true,
                icon: "warning",
              });
            }
            dispatch(keyCloakLoader(false));
          });
      } else {
        if (state.email) {
          data.email = state.email;
        }
        LoginService.generateOtp(data)
          .then((response) => {
            if (response.data.data === "OTP_SENT") {
              updateState("screen", "otp");
              if (resend) {
                updateState("onResentOtp", !state.onResentOtp);
              }
            } else if (
              response.data.data === "PHONE_NUMBER_ALREADY_REGISTERED"
            ) {
              toast.error(
                "Given mobile number already registered, try to login!"
              );
            } else if (response.data.data === "EMAIL_ALREADY_EXIST") {
              toast.error("Given email already exist, try to new email!");
            } else {
              toast.error("Something went wrong, please try later!");
            }
            dispatch(keyCloakLoader(false));
          })
          .catch((error) => {
            if (error?.message === "Network Error") {
              Swal.fire({
                title: "Network issue detected. Kindly verify your connection.",
                confirmButtonText: "Try Again",
                reverseButtons: true,
                icon: "warning",
              });
            } else {
              Swal.fire({
                title:
                  "Access is temporarily unavailable. Please try again later.",
                confirmButtonText: "Try Again",
                reverseButtons: true,
                icon: "warning",
              });
            }
            dispatch(keyCloakLoader(false));
          });
      }
    }
  };

  const loginOtpSend = (resend) => {
    axios({
      method: "post",
      url: `${KEY_CLOAK_URL}realms/yuukke/sms-authentication/otp/${state.phoneNumber}`,
    })
      .then((response) => {
        console.log("response", response);
        dispatch(keyCloakLoader(false));
        updateState("menu", 3);
        if (resend) {
          console.log("resend-otp", resend);
          updateState("onResentOtp", !state.onResentOtp);
        }
      })
      .catch((e) => {
        console.log("e", e);
        updateState("menu", 3);
        dispatch(keyCloakLoader(false));
        if (resend) {
          updateState("onResentOtp", !state.onResentOtp);
        }
      });
  };

  const verifyOtp = () => {
    if (state.otp && state.otp?.length === 6 && state.isLoginScreen) {
      dispatch(keyCloakLoader(true));
      let data = {
        mobile_number: state.phoneNumber,
        otp: state.otp,
        client_id: CLIENT_ID,
      };
      try {
        LoginService.validateLoginOtp(data)
          .then((response) => {
            const result = response.data;
            if (result?.access_token) {
              dispatch(updateKeyCloakToken(result));
            } else {
              toast.error("Enter valid otp!");
              dispatch(keyCloakLoader(false));
            }
          })
          .catch((error) => {
            dispatch(keyCloakLoader(false));
            toast.error("Enter valid otp!");
          });
      } catch (e) {
        dispatch(keyCloakLoader(false));
        toast.error("Something went wrong, please try later!");
      }
    } else if (
      state.otp &&
      state.otp.length === 6 &&
      state.screen !== "mobile-signIn"
    ) {
      dispatch(keyCloakLoader(true));
      let data = {
        phoneNumber: state.phoneNumber,
        otp: state.otp,
      };
      LoginService.validateOtp(data)
        .then((response) => {
          if (response.data.data === "VALID_OTP") {
            let details = {
              name: state.name,
              phoneNumber: state.phoneNumber,
              clientId: CLIENT_ID,
              location: state.country.label,
              email: state.email,
            };
            let loginUpdate = {
              countryId: state.country.id,
              personalLanguage: state.language.value,
              country: state.country.label,
            };
            dispatch(mobileNumberRegister(details, loginUpdate));
          } else {
            toast.error("Invalid otp!");
            dispatch(keyCloakLoader(false));
          }
        })
        .catch((e) => {
          dispatch(keyCloakLoader(false));
          toast.error("Something went wrong, please try later!");
        });
    } else {
      toast.warning("Please fill valid otp");
    }
  };

  const getHidedList = () => {
    if (!state.phoneNumber) {
      return "";
    }
    const data = state.phoneNumber.slice(0, -4) + "*".repeat(4);
    return data;
  };

  const previewPhoneNumber = useMemo(() => getHidedList(), [state.phoneNumber]);

  const onOtpSubmit = (otp) => {
    updateState("otp", otp);
  };

  const submitFormEmail = (e, listener) => {
    if (!listener) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (!state.email.trim() || (state.password.length < 5 && !state.forgot)) {
      toast.warning(
        !state.email ? "Enter valid email" : "Enter valid password"
      );
      return;
    }
    if (!isValidEmail(state.email)) {
      toast.warning("Enter valid email");
      return;
    }
    if (state.forgot) {
      dispatch(keyCloakLoader(true));
      const request = {
        uuid: state.email,
        action: "UPDATE_PASSWORD",
      };
      LoginService.forgotPassword(request)
        .then((response) => {
          // Handle success
        })
        .catch((e) => {
          console.log("e", e);
        })
        .finally(() => dispatch(keyCloakLoader(false)));
      return;
    }
    if (state.screen === "register") {
      if (!state.firstName.trim() || !state.lastName.trim()) {
        toast.warning(
          !state.firstName ? "Enter valid firstName" : "Enter valid lastName"
        );
        return;
      }
      if (!state.password || !state.confirmPassword) {
        toast.warning(
          !state.password ? "Enter password" : "Enter confirm Password"
        );
        return;
      }
      if (state.password !== state.confirmPassword) {
        toast.warning("Password not matching");
        return;
      }
      if (!passwordCheck(state.password)) {
        toast.warn(
          "Password should be at least 8 characters long, containing one capital alphabet, one lowercase alphabet, one number, and one special character (#?!@*())"
        );
        return;
      }
      dispatch(keyCloakLoader(true));
      const request = {
        username: state.email.trim(),
        firstName: state.firstName.trim(),
        enabled: true,
        emailVerified: false,
        totp: false,
        lastName: state.lastName.trim(),
        email: state.email.trim().toLowerCase(),
        requiredActions: ["VERIFY_EMAIL"],
        credentials: [
          {
            type: "password",
            value: state.password.trim(),
          },
        ],
      };
      LoginService.keyClockCreateUser(request)
        .then((response) => {
          const result = response.data.data;
          dispatch(keyCloakLoader(false));
          if (result === 1) {
            // emailRegisterSuccess();
          } else {
            toast.error("User already exists!");
            setState({
              ...state,
              email: "",
              password: "",
              confirmPassword: "",
            });
          }
        })
        .catch((e) => {
          toast.error("User already exists!");
          console.error(e);
          dispatch(keyCloakLoader(false));
          setState({
            ...state,
            email: "",
            password: "",
            confirmPassword: "",
          });
          const errorData = {
            apiName: `${API_URL}keycloak/createUser`,
            exceptionName: `User Already exists ${state.email}`,
            errorMessage: e,
            userId: 0,
            emailId: "",
            requestData: request,
          };
          saveUserExceptionMeth(errorData);
        });
      return;
    }
    // Login
    dispatch(keyCloakLoader(true));
    const params = new URLSearchParams();
    params.append("grant_type", "password");
    params.append("client_id", CLIENT_ID);
    params.append("client_secret", "34471d72-6ade-4959-af93-67fa7760e64c");
    params.append("username", state.email.trim());
    params.append("password", state.password.trim());
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };
    axios
      .post(
        KEY_CLOAK_URL + "realms/yuukke/protocol/openid-connect/token",
        params,
        config
      )
      .then((response) => {
        console.log("login-response", response);
        if (response.data?.access_token) {
          dispatch(updateKeyCloakToken(response.data));
        } else {
          Swal.fire({
            title: "INVALID CREDENTIALS",
            showCancelButton: true,
            confirmButtonText: "Create New Account",
            cancelButtonText: "Reenter Credential",
            reverseButtons: true,
            icon: "warning",
            iconHtml: `<img src=${Notfound} style="width: 50px; height: 50px;">`,
          }).then((result) => {
            if (result.value) {
              // createAccountPage(2);
            }
            updateState("password", "");
            dispatch(keyCloakLoader(false));
          });
        }
      })
      .catch((error) => {
        const status = error?.response?.data?.error_description;
        let exceptionName = null;
        if (error?.message === "Network Error") {
          exceptionName = `User Network Not Connected to System. User Email : ${state.email}`;
          Swal.fire({
            title: "Network issue detected. Kindly verify your connection.",
            confirmButtonText: "Try Again",
            reverseButtons: true,
            icon: "warning",
          });
          dispatch(keyCloakLoader(false));
        } else if (status === "Account disabled") {
          exceptionName = `User Account Disabled : ${state.email}`;
          toast.error("Account disabled");
          updateState("password", "");
          dispatch(keyCloakLoader(false));
        } else {
          exceptionName = `INVALID CREDENTIALS : ${state.email}`;
          Swal.fire({
            title: "INVALID CREDENTIALS",
            showCancelButton: true,
            confirmButtonText: "Create New Account",
            cancelButtonText: "Reenter Credential",
            reverseButtons: true,
            icon: "warning",
            iconHtml: `<img src=${Notfound} style="width: 50px; height: 50px;">`,
          }).then((result) => {
            if (result.value) {
              // createAccountPage(2);
            }
            updateState("password", "");
            dispatch(keyCloakLoader(false));
          });
        }
        const errorData = {
          apiName:
            KEY_CLOAK_URL + "realms/yuukke/protocol/openid-connect/token",
          exceptionName: exceptionName ? exceptionName : "something_wrong",
          errorMessage: error,
          userId: 0,
          emailId: "",
          requestData: params,
        };
        saveUserExceptionMeth(errorData);
      });
  };

  const saveUserExceptionMeth = (data) => {
    try {
      if (data.errorMessage) {
        data.errorMessage = JSON.stringify(data.errorMessage);
      }
      if (data.requestData) {
        data.requestData = JSON.stringify(data.requestData);
      }
      LoginService.saveUserException(data)
        .then((response) => {
          console.log("USER EXCEPTION SAVING COMPLETED");
        })
        .catch((er) => {});
    } catch (e) {
      console.log("USER EXCEPTION SAVING ERROR", e);
    }
  };

  return (
    <div className="womenconnect-login-page">
      {loginLoader && (
        <div className="loading-overlay">
          <div className="spinner"></div>
          <p>Loading, please wait...</p>
        </div>
      )}
      
      <div className="wc-login-container">
        {/* Left Section: Background Image with Overlay Text (Updated to Match Screenshot Exactly) */}
       {/* Left Section: Background Image with Gradient and Text Overlay */}
<div className="wc-left-section">
  <div className="wc-overlay"></div>
  <img src={login} alt="Empowered Woman Entrepreneur" className="wc-background-image" />

  <div className="wc-left-content">
    <div className="wc-logo">WomenConnect</div>

    <h1 className="wc-title">Empowering Women Entrepreneurs Worldwide</h1>
    <p className="wc-subtitle">
      Join thousands of successful women building their dreams together
    </p>

    <div className="wc-stats">
      <div className="wc-stat">
        <h3>10K+</h3>
        <p>Active Members</p>
      </div>
      <div className="wc-stat">
        <h3>5K+</h3>
        <p>Businesses</p>
      </div>
      <div className="wc-stat">
        <h3>4.9</h3>
        <p>Rating</p>
      </div>
    </div>

    <div className="wc-review-box">
      <div className="wc-stars">
        {[...Array(5)].map((_, i) => (
          <FaStar key={i} className="wc-review-star" />
        ))}
      </div>
      <p className="wc-review-text">
        "WomenConnect helped me grow my business beyond my wildest dreams. 
        The community support is incredible!"
      </p>
      <div className="wc-review-user">
        <div className="wc-review-avatar">SM</div>
        <div>
          <h4>Sarah Miller</h4>
          <p>Wellness Coach</p>
        </div>
      </div>
    </div>
  </div>
</div>


        {/* Right Section: Login Form with Matching Inputs and Elements */}
        <div className="wc-right-section">
          {/* Back Button if onBack prop exists */}
          {onBack && state.screen === "login" && (
            <button 
              className="wc-back-link wc-main-back-btn" 
              onClick={handleBackToHome}
              style={{ 
                position: 'absolute', 
                left: '20px', 
                top: '20px', 
                background: 'none', 
                border: 'none',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                color: '#9ca3af',
                fontSize: '0.9rem',
                fontWeight: '500',
                cursor: 'pointer',
                padding: '8px 16px',
                borderRadius: '6px',
                transition: 'color 0.2s ease',
                zIndex: 10
              }}
              onMouseOver={(e) => e.target.style.color = '#89153b'}
              onMouseOut={(e) => e.target.style.color = '#9ca3af'}
            >
              <FaArrowLeft /> Back to Home
            </button>
          )}

          <div className="wc-login-form-wrapper">
            {state.screen === "register" ? (
              <div className="wc-register-form">
                <h2>Create Your Account</h2>
                <form onSubmit={(e) => submitForm(e, false)}>
                  <div className="wc-form-group">
                    <label>What is your name? *</label>
                    <div className="wc-input-with-icon">
                      <input
                        value={state.name}
                        type="text"
                        placeholder="Enter your name"
                        required
                        onChange={(e) => updateState("name", e.target.value)}
                      />
                      <FaRegUser className="wc-input-icon" />
                    </div>
                  </div>
                  
                  <div className="wc-form-group">
                    <label>Which country are you from? *</label>
                    <Select
                      onChange={(e) => updateState("country", e)}
                      options={state.countryList}
                      value={state.country}
                      placeholder="Select Country"
                      required
                      menuPortalTarget={dBody}
                      styles={dropFlowStyle}
                    />
                  </div>
                  
                  <div className="wc-form-group">
                    <label>Language *</label>
                    <Select
                      onChange={(e) => updateState("language", e)}
                      options={language}
                      value={state.language}
                      placeholder="Select Language"
                      required
                      menuPortalTarget={dBody}
                      styles={dropFlowStyle}
                    />
                  </div>
                  
                  <div className="wc-form-group">
                    <label>Email *</label>
                    <div className="wc-input-with-icon">
                      <input
                        value={state.email}
                        type="email"
                        placeholder="Enter your email"
                        required
                        onChange={(e) => updateState("email", e.target.value)}
                      />
                      <MdOutlineMail className="wc-input-icon" />
                    </div>
                  </div>
                  
                  <div className="wc-form-group">
                    <label>Mobile Number *</label>
                    <PhoneInput
                      country={"in"}
                      value={state.phoneNumber}
                      onChange={(phone) => updateState("phoneNumber", phone)}
                      required
                      containerClass="wc-phone-input-container"
                      inputClass="phone-input"
                    />
                  </div>
                  
                  <button type="submit" className="wc-signup-btn">
                    Continue
                  </button>
                </form>

                <div className="back-to-home">
                  <button className="wc-back-link" onClick={backToMainLogin}>
                    <FaArrowLeft /> Back to Sign In
                  </button>
                </div>
              </div>
            ) : state.screen === "mobile-signIn" ? (
              <div className="wc-mobile-signin">
                <h2>Sign in with Mobile</h2>
                <div className="wc-form-group">
                  <label>Phone number</label>
                  <PhoneInput
                    country={"in"}
                    value={state.phoneNumber}
                    onChange={(phone) => updateState("phoneNumber", phone)}
                    required
                    containerClass="wc-phone-input-container"
                    inputClass="phone-input"
                    className="wc-phone-input-new"
                  />
                </div>
                <button
                  onClick={(e) => submitForm(e, false)}
                  className="wc-signup-btn"
                >
                  Send OTP
                </button>

                <div className="back-to-home">
                  <button className="wc-back-link" onClick={backToMainLogin}>
                    <FaArrowLeft /> Back to Sign In
                  </button>
                </div>
              </div>
            ) : state.screen === "otp" ? (
              <div className="wc-otp-verification">
                <h2>Verify your number</h2>
                <p>Enter the code we've sent by text to {previewPhoneNumber}</p>
                
                <div className="wc-otp-input-container">
                  <OtpInput length={6} onOtpSubmit={onOtpSubmit} />
                </div>
                
                <button
                  onClick={verifyOtp}
                  className="wc-signup-btn"
                >
                  Verify
                </button>

                <div className="back-to-home">
                  <button className="wc-back-link" onClick={backToMainLogin}>
                    <FaArrowLeft /> Back to Sign In
                  </button>
                </div>
              </div>
            ) : (
              // Main Login Form (default screen) - Matching Screenshot Inputs/Elements
              <div className="wc-login-form">
                <h2>Welcome Back</h2>
                <p>Enter your credentials to access your account</p>
                
                <form onSubmit={(e) => submitFormEmail(e, false)}>
                  <div className="wc-form-group">
                    <label>Email</label>
                    <div className="wc-input-with-icon">
                      <input
                        value={state.email}
                        type="email"
                        placeholder="Username or Email"
                        required
                        onChange={(e) => updateState("email", e.target.value)}
                      />
                      <MdOutlineMail className="wc-input-icon" />
                    </div>
                  </div>
                  
                  <div className="wc-form-group">
                    <label>Password</label>
                    <div className="wc-input-with-icon">
                      <input
                        value={state.password}
                        type={state.inputType}
                        placeholder="Enter password"
                        required
                        onChange={(e) => updateState("password", e.target.value)}
                      />
                      <span
                        onClick={() =>
                          updateState(
                            "inputType",
                            state.inputType === "password" ? "text" : "password"
                          )
                        }
                        className="wc-toggle-password"
                      >
                        {state.inputType === "password" ? (
                          <FaEyeSlash className="wc-input-icon" />
                        ) : (
                          <FaEye className="wc-input-icon" />
                        )}
                      </span>
                    </div>
                  </div>

                  <div className="wc-remember-forgot">
                    <div className="wc-remember-me">
                      <input type="checkbox" id="remember" />
                      <label htmlFor="remember">Remember me</label>
                    </div>
                    <a href="#" className="wc-forgot-password">Forgot password?</a>
                  </div>
                  
                  <button type="submit" className="wc-login-btn">
                    Log In
                  </button>
                </form>
                
                {/* Separate Divider */}
                <div className="wc-divider"></div>
                
                <div className="wc-social-login">
                  <button
                    className="wc-phone-login-btn"
                    onClick={() => {
                      setState((previous) => ({
                        ...previous,
                        isLoginScreen: true,
                        screen: "mobile-signIn",
                      }));
                    }}
                  >
                    <MdPhone style={{ marginRight: '8px', height: '20px', width: '20px' }} />
                    Log in by Phone Number
                  </button>
                  
                  <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
                    <GoogleLogin
                      outer={true}
                      updateToken={updateToken}
                      className="wc-login-options-img"
                      errorGettingToken={errorGettingToken}
                      title="Continue with Google"
                    />
                  </GoogleOAuthProvider>
                  
                  <p className="wc-signup-link">
                    Don't have an account?{' '}
                    <span
                      onClick={() =>
                        setState((previous) => ({
                          ...previous,
                          isLoginScreen: false,
                          screen: "register",
                        }))
                      }
                    >
                      Sign up here
                    </span>
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default withRouter(WomenConnectLoginpage);
